<!-- ------------------------------------------------------------------------------------------------------------------ -->


<!-- ------------------------------------------------------------------------------------------------------------------ -->

<div class="main-wrapper " nxLayout="grid maxwidth">
  <!--  <div class="container">-->
  <!--    <div class="row">-->
  <!--      <h1>Angular and LocalStorage</h1>-->
  <!--      <p>We, save your background color, if you want returns :) </p>-->
  <!--    </div>-->
  <!--    <div class="row">-->
  <!--      <input-->
  <!--        type="color"-->
  <!--        #colorPicker-->
  <!--        [value]="userBackgroundColor"-->
  <!--        (change)="saveBackgroundColor(colorPicker.value)"-->
  <!--      />-->
  <!--    </div>-->
  <!--    <button class="btn-remove" (click)="removePreferences()">-->
  <!--      Remove preferences-->
  <!--    </button>-->
  <!--  </div>-->
  <div class="nx-margin-top-2m" nxRow>
    <div class="nx-margin-bottom-2m" nxCol="12,12,8,8,8" nxColOffset="0,0,2,2,2">
      <nx-multi-stepper #stepper [linear]="true" currentStepLabel="Step" (selectionChange)="updateStepper($event)">

        <nx-step [stepControl]="stepThreeForm" label="{{'copy.step_3.label'|translate}}">
          <form [formGroup]="stepThreeForm">
            <div class="nx-margin-top-4m" nxRow>

              <div class="nx-margin-bottom-l u-text-center" nxCol="8" nxColOffset="2">
                <p nxCopytext="large"  [innerHtml]="('copy.step_1.info'|translate)">
                </p>

              </div>
              <div class="nx-margin-bottom-2m" nxCol="12" nxColOffset="0">
                <h4 nxHeadline="subsection-xsmall" class="nx-font-weight-bold">
                  {{'copy.section_headline_1'|translate}}
                </h4>
              </div>

              <div nxCol="12,12" class="nx-margin-bottom-m">
                <!--          <nx-checkbox class="nx-margin-bottom-s" [(checked)]="checkedRaw"-->
                <nx-checkbox labelSize="large" class=""
                             formControlName="isCustomer">{{'app.form.client'|translate}}
                </nx-checkbox>
              </div>
              <div class="nx-margin-bottom-2m" nxCol="12,12,12,6" nxColOffset="0">
                <nx-formfield nxLabel="{{'core.label.firstname'|translate}}, {{'core.label.lastname'|translate}}">
                  <input formControlName="firstname" nxInput required/>
                </nx-formfield>
              </div>
              <div class="nx-margin-bottom-2m" nxCol="12,12,12,6" nxColOffset="0">
                <nx-formfield nxLabel="{{'core.label.firstname'|translate}}, {{'core.label.lastname'|translate}}">
                  <input formControlName="lasttname" nxInput required/>
                </nx-formfield>
              </div>


              <div class="nx-margin-bottom-2m" nxCol="12,12,12,6" nxColOffset="0">
                <nx-formfield nxLabel="{{'core.label.email'|translate}}">
                  <input formControlName="email" nxInput type="email" required/>
                </nx-formfield>
              </div>
              <div class="nx-margin-bottom-2m" nxCol="12,12,12,6" nxColOffset="0">
                <nx-formfield>
                  <nx-formfield-label>{{ 'core.label.phonenumber'|translate }}</nx-formfield-label>
                  <nx-phone-input formControlName="phone" countryCode="CH"></nx-phone-input>
                </nx-formfield>
              </div>
              <div class="" nxCol="12,12,12" nxColOffset="0">
                <nx-formfield nxLabel="{{'core.label.zip'|translate}}">
                  <input formControlName="zip" nxInput required  (change)="changeZip()" pattern="\d*" maxlength="4"/>
                  <span nxFormfieldPrefix>CH-</span>
                </nx-formfield>
              </div>
              <div nxCol="12,12" class="nx-margin-bottom-2m nx-margin-top-2m">
                <p nxCopytext="small" class="u-text-center">
                  {{'app.form.zipcodehint'|translate}}

                </p>
              </div>
              <div class="nx-margin-bottom-4m" nxCol="12" nxColOffset="0">
                <nx-checkbox-group formControlName="availability" >
                  <nx-label>{{'core.label.availability'|translate}}</nx-label>
                  <div class="horizontal-checkboxes">
                  <nx-checkbox value="8-12 Uhr" class="">8-12 Uhr</nx-checkbox>
                  <nx-checkbox value="12-13 Uhr" class="nx-margin-left-s">12-13 Uhr</nx-checkbox>
                  <nx-checkbox value="13-17 Uhr" class="nx-margin-left-s">13-17 Uhr</nx-checkbox>
                  <nx-checkbox value="17-20 Uhr" class="nx-margin-left-s">17-20 Uhr</nx-checkbox>
                  </div>
                </nx-checkbox-group>

              </div>

              <!--<div class="nx-margin-bottom-2m nx-margin-top-m u-text-align-center" nxCol="12,12,12,10"
                   nxColOffset="0,0,0,1">
                <p nxCopytext="medium" class=" u-text-align-center" [innerHtml]=" ('app.form.legal'|translate)">

              </div>-->
            </div>
          </form>
          <div class="nx-margin-top-l " nxRow>
            <div nxCol="12,12" class="nx-margin-bottom-2m">
              <p nxCopytext="medium" class=" u-text-align-center" [innerHtml]="'app.form.legal'|translate">

              </p>
            </div>
            <div class="nx-margin-bottom-2m u-text-align-center" nxCol="12" nxColOffset="0">

              <button nxButton="primary " (click)="onsubmit($event)" type="button" class="nx-margin-top-m">
                {{ 'core.button.submit' | translate }}

              </button>
            </div>
          </div>
        </nx-step>
        <nx-step label="{{'copy.step_4.label'|translate}}">
          <div class="nx-margin-top-l" nxRow>

            <div class="nx-margin-bottom-2m nx-margin-top-4m  u-text-align-center" nxCol="12" nxColOffset="0">
              <nx-icon
                name="check"
                fill="true"
                outline="true"
                size="m"
                style="background:#3DA556"
              ></nx-icon>
            </div>
            <div class="nx-margin-bottom-2m u-text-align-center" nxCol="12" nxColOffset="0">
              <h2 nxHeadline="section">{{ 'success.headline' | translate }}</h2>
            </div>
            <div class="nx-margin-bottom-5xl u-text-align-center" nxCol="8" nxColOffset="2">
              <p nxCopytext="large">
                {{ 'success.copy' | translate }}
              </p>
            </div>
            <div class="nx-margin-bottom-2m u-text-align-center" nxCol="12" nxColOffset="0">
              <h2 nxHeadline="section" class="u-text-uppercase">{{ 'success.headline_2'|translate }}</h2>
            </div>
          </div>
        </nx-step>

      </nx-multi-stepper>

    </div>

  </div>
</div>

<!-- ------------------------------------------------------------------------------------------------------------------ -->


